import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ServicePaymentInfo } from '@app/shared/models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-request-select-service-number-detail',
    imports: [
        CommonModule,
        TranslateModule,
        MatFormFieldModule,
        MatInputModule
    ],
    templateUrl: './request-select-service-number-detail.component.html',
    styleUrls: ['./request-select-service-number-detail.component.scss']
})
export class RequestSelectServiceNumberDetailComponent implements OnInit {
  @Input() paymentInfo: ServicePaymentInfo;

  constructor() {
  }
  ngOnInit() {
  }

}
